
export function Pagination({ result, changePage }: any) {
    return (<>
        {result.pageable &&
            <div className="block vtmn-flex vtmn-flex-row vtmn-flex-wrap vtmn-justify-center">

                {!result.first &&
                    <button className="vtmn-btn vtmn-btn_size--small vtmn-m-3" onClick={() => changePage(result.number - 1)}>
                        Previous
                    </button>
                }

                <button className={`vtmn-btn vtmn-btn_size--small vtmn-btn--icon-alone vtmn-m-1 vtmn-mt-3 ${result.first ? 'vtmn-btn_variant--secondary' : ''}`} aria-label="Goto page 1" onClick={() => changePage(0)}>
                    1
                </button>

                {!result.first && result.total_pages > 1 &&
                    <button className="vtmn-btn vtmn-btn_size--small vtmn-btn--icon-alone vtmn-m-1 vtmn-mt-3  vtmn-btn_variant--secondary" onClick={() => changePage(result.number)}
                        aria-label={`Goto page ${result.number + 1}`}>
                        {result.number + 1}
                    </button>
                }

                {result.total_pages > 1 &&
                    <>
                        {result.total_pages >= result.number + 2 &&

                            <button className="vtmn-btn vtmn-btn_size--small vtmn-btn--icon-alone vtmn-m-1 vtmn-mt-3" onClick={() => changePage(result.number + 1)}
                                aria-label={`Goto page ${result.number + 2}`}>
                                {result.number + 2}
                            </button>
                        }

                        {!result.last && result.number + 2 !== result.total_pages && result.total_pages > 4 &&
                            <button className="vtmn-btn vtmn-btn_size--small vtmn-btn--icon-alone vtmn-m-1 vtmn-mt-3" onClick={() => changePage(result.total_pages - 1)} aria-label={`Goto page ${result.total_pages}`}>
                                {result.total_pages}
                            </button>
                        }
                        {!result.last &&
                            <button className="vtmn-btn vtmn-btn_size--small vtmn-m-3" onClick={() => changePage(result.number + 1)}>
                                Next page
                            </button>
                        }
                    </>
                }
            </div>
        }
    </>)
}